import enUS from 'date-fns/locale/en-US'
import ru from 'date-fns/locale/ru'

export default { en: enUS, ru }
